module.exports = __webpack_public_path__ + "img/gear-wide.2f90707d.svg";